import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
/*
 * 조회된 데이터를 엑셀로 변환하는 function
 * 사용 라이브러리
 * npm install xlsx file-saver
 * EX) // 엑셀생성 시트 등록 정보
    const filsInfo = {
        // 파일명
        fileNm : '샘플파일',
        // 헤더정보
        headers : [["데이터 보고서"],
                   ["코드", "", "이름"]],
        // 셀병합 불필요 : []
        // 셀병합 필요   : s:시작셀(start, {r:행번호, c:열번호}), e:끝셀(end, {r:행번호, c:열번호})
        titleMerge : [{ s: { r: 0, c: 0 }, e: { r: 0, c: 1 } }],
        // 데이터 시작줄
        stRow : "A3",
        // 시트명(필수 아님)
        sheetNm : "sheet1",
    };
*/

export const excelDown = (fileInfo,  data) => {
    let rowCnt = 1;
    // 1. JSON → Worksheet 변환
    const ws = XLSX.utils.json_to_sheet(data);

    // 2. 시트 상단에 타이틀(머리글) 추가
    fileInfo.headers.forEach(element => {
        XLSX.utils.sheet_add_aoa(ws, [element], { origin: "A" + rowCnt });
        rowCnt++;
    });
    // XLSX.utils.sheet_add_aoa(ws, [["번호", "이름"]], { origin: "A2" });
    // 병합 범위 지정 (A1~C1까지 병합)
    ws["!merges"] = fileInfo.titleMerge;

    // 3. 지정 시작 줄부터 데이터 삽입
    XLSX.utils.sheet_add_json(ws, data, {
        origin: fileInfo.stRow ? fileInfo.stRow : "A2",     // data시작 줄(없는 경우 2번째 줄부터)
        skipHeader: true, // JSON 키 자동 헤더는 무시
    });

    // 4. Workbook 생성
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, fileInfo.sheetNm ? fileInfo.sheetNm : "sheet1");

    // 5. Excel 파일 생성 (ArrayBuffer)
    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const file = new Blob([wbout], { type: "application/octet-stream" });

    // 6. 다운로드
    saveAs(file, fileInfo.fileNm ? fileInfo.fileNm+'.xlsx' : "Download_file.xlsx");
  
};